<template>
  <v-container v-if="egreso">
    <v-toolbar flat>
      <v-btn icon @click="$router.push({name: 'pos.egresos.gastos.list'})">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Actualizar egreso</v-toolbar-title>
    </v-toolbar>

    <gastos-form
      :egreso="egreso"
      @process:register="actualizarEgreso"
      textButton="Actualizar"
    />
   
  </v-container>
</template>

<script>
import GastosForm from "@/views/pos/egresos/components/GastosForm.vue";
import { getApiErrorMessage } from "@/util/apiError";

export default {
  name: "egreso.actualizar",
  components: { GastosForm },
  data() {
    return {
      egreso: null,
      detalles_server_update: [],
      detalles_server_delete: [],
      detalles_server_new: [],
    };
  },
  methods: {
    async fetchEgreso(id) {
      const response = await this.axios.get(`/egresos/ingresoegreso/${id}`);
      this.egreso = response.data;
    },
    async actualizarEgreso() {
      try {
        // si ahora solo existe un detalle, se envía como array con un único elemento
        this.egreso.detalles = [this.egreso.detalle];

        await this.axios.put(
          `/egresos/ingresoegreso/${this.egreso.id}`,
          this.egreso
        );
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Egreso actualizado",
          icon: "mdi-check",
          timeout: 2500,
        });
        this.$router.push({name: "pos.egresos.gastos.list"});
      } catch (error) {
        const text = getApiErrorMessage(
          error,
          "Error al actualizar el egreso"
        );
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "primary",
          text,
          icon: "mdi-information",
          timeout: 4000,
        });
      }
    },
    async actualizarEgresoMultipleDetalle() {
      try {
        let detalles = [
          ...this.detalles_server_update,
          ...this.detalles_server_delete,
          ...this.detalles_server_new,
        ];
        this.egreso.detalles = detalles;

        await this.axios.put(
          `/egresos/ingresoegreso/${this.egreso.id}`,
          this.egreso
        );
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Egreso actualizado",
          icon: "mdi-check",
          timeout: 2500,
        });
        this.$router.push("/egresos");
      } catch (error) {
        const text = getApiErrorMessage(
          error,
          "Error al actualizar el egreso"
        );
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "primary",
          text,
          icon: "mdi-information",
          timeout: 4000,
        });
      }
    },
  },
  created() {
    const id = this.$route.params.id;
    this.fetchEgreso(id);
  },
};
</script>
